<template>
  <span>{{ localizedName }}</span>
</template>

<script>
export default {
  props: ["item"],
  computed: {
    localizedName() {
      const instruction = this.item?.instruction;
      const lang = this.toEmployeeLang(this.$i18n.locale);

      const name = instruction?.name;
      if (typeof name === "string") return name;

      const list = Array.isArray(name) ? name : [];
      const match = list.find((n) => n.language === lang)?.name;
      const fallback = list.find((n) => n.language === "GER")?.name; // or ENG
      return match || fallback || "";
    },
  },
  methods: {
    toEmployeeLang(locale) {
      if (locale === "de") return "GER";
      if (locale === "en") return "ENG";
      return "ENG";
    },
  },
};
</script>
